import { useFeatureFlagging as useFeatureFlagging$1 } from '@iwt-core-web/feature-flagging';
export { FeatureFlaggingProvider } from '@iwt-core-web/feature-flagging';

/**
 * Legacy `@aviv-trak/feature-flagging` hook surface, backed by the internalized `@iwt-core-web/feature-flagging` context.
 *
 * It restores the legacy semantics that differ from the new hook:
 * - `getFeatureFlag(key)` returns the raw variation value (`string | undefined`), not a boolean with fallback;
 * - `isInitialized`/`isLoaded` are `true` only once feature flags are available (Kameleoon behavior).
 */ const useFeatureFlagging = ()=>{
    const { getFeatureFlags } = useFeatureFlagging$1();
    const featureFlags = getFeatureFlags();
    return {
        /**
     * Get available feature flags.
     * @returns All feature flags available in the context or undefined.
     */ getFeatureFlags: ()=>featureFlags,
        /**
     * Retrieves the value of a feature flag from its key.
     * @param key The feature flag key.
     * @returns The feature flag value or undefined.
     */ getFeatureFlag: (key)=>featureFlags?.[key],
        /**
     * @deprecated use `getFeatureFlag` instead.
     */ getVariation: (key)=>featureFlags?.[key],
        /**
     * @returns True if the client is initialized AND FeatureFlags are available.
     */ isInitialized: Boolean(featureFlags),
        /**
     * @deprecated use `isInitialized` instead.
     */ isLoaded: Boolean(featureFlags)
    };
};

export { useFeatureFlagging };
